var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconMenuBillingInactive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "16px",
    height: "16px",
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Eraklient",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("g", {
    id: "UI-Framework",
    transform: "translate(-495.000000, -315.000000)",
    fill: "#212121"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-8",
    transform: "translate(495.000000, 311.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icon-Menu_Billing_Inactive",
    transform: "translate(0.000000, 4.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15,12 C15.553,12 16,12.447 16,13 C16,14.657 14.657,16 13,16 L3,16 C1.343,16 0,14.657 0,13 L0,1 C0,0.447 0.447,0 1,0 L11,0 C11.553,0 12,0.447 12,1 L12,12 L15,12 Z M4,13 C4,12.447 4.447,12 5,12 L10,12 L10,2 L2,2 L2,13 C2,13.553 2.447,14 3,14 C3.553,14 4,13.553 4,13 Z M13,14 C13.553,14 14,13.553 14,13 L6,13 C6,13.353 5.928,13.686 5.816,14 L13,14 Z M7,4 C7.553,4 8,4.447 8,5 C8,5.553 7.553,6 7,6 L5,6 C4.447,6 4,5.553 4,5 C4,4.447 4.447,4 5,4 L7,4 Z",
    id: "Combined-Shape"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconMenuBillingInactive);
export default __webpack_public_path__ + "static/media/Icon-Menu_Billing_Inactive.889190a7607bab954e8912339c7e203b.svg";
export { ForwardRef as ReactComponent };